import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

// import { useTranslation } from 'react-i18next';

import { linkConnection } from '@/api/storageApi';
import { useVToast } from '@/package/kiska/src/component/UI/VToast';

export const useLinkConnection = () => {
  const { addToast } = useVToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: linkConnection,
    onSuccess: () => {
      addToast({
        message: t('storage.externalStorageLinkCompleted.entoconid'),
        variant: 'success',
      });
    },
    onError: err => {
      addToast({
        message: t((err as any).data.resultMsg),
        variant: 'error',
      });
    },
  });
};
